import React from 'react';

function Machine() {
  return <div>Machine</div>;
}

export default Machine;
